import { selectResource } from '../resource/resourceSelectors'

export const selectFullSelectedLoan = state =>
  selectResource(state).fullSelectedLoan?.data || {}
export const selectHasPrimaryContact = state =>
  selectFullSelectedLoan(state).consumers?.some(x => x.is_primary_contact) ?? false
